import { initBreadcrumb } from "../modules/Breadcrumb";
import { scrollToBottom } from "../modules/ScrollToBottom";

export function initPageHeader(){
    scrollToBottom();
    initBreadcrumb();
    setMainPaddingTop()
    window.addEventListener('resize', function() {
        setMainPaddingTop()
    });
}


function setMainPaddingTop(){
    const customNavbar=document.querySelector('.custom-navbar');
    const mainElm=document.querySelector('main');
    const customNavbarHeight=customNavbar.clientHeight;
    mainElm.style.paddingTop=customNavbarHeight+'px';
}
